export interface MetricSample {
  name: string;
  labels: Record<string, string>;
  value: number;
}

export function parsePrometheus(text: string): MetricSample[] {
  const samples: MetricSample[] = [];
  for (const line of text.split('\n')) {
    const trimmed = line.trim();
    if (!trimmed || trimmed.startsWith('#')) {
      continue;
    }
    const match = trimmed.match(
      /^([a-zA-Z_:][a-zA-Z0-9_:]*)(\{([^}]*)\})?\s+([+-]?[\d.eE+-]+|NaN|\+Inf|-Inf)$/
    );
    if (!match) {
      continue;
    }
    const name = match[1];
    const labelStr = match[3];
    const value = Number.parseFloat(match[4]);
    if (Number.isNaN(value)) {
      continue;
    }
    samples.push({
      name,
      labels: parseLabels(labelStr ?? ''),
      value,
    });
  }
  return samples;
}

function parseLabels(labelStr: string): Record<string, string> {
  const labels: Record<string, string> = {};
  if (!labelStr) {
    return labels;
  }
  const re = /([a-zA-Z_][a-zA-Z0-9_]*)\s*=\s*"((?:\\.|[^"\\])*)"/g;
  let m: RegExpExecArray | null;
  while ((m = re.exec(labelStr)) !== null) {
    labels[m[1]] = m[2];
  }
  return labels;
}

export function metricValuesByLabel(
  samples: MetricSample[],
  metricName: string,
  labelName: string
): Map<string, number> {
  const map = new Map<string, number>();
  for (const sample of samples) {
    if (sample.name !== metricName) {
      continue;
    }
    const labelValue = sample.labels[labelName];
    if (labelValue !== undefined) {
      map.set(labelValue, sample.value);
    }
  }
  return map;
}

export const METRIC_NAMES = {
  messagesProcessed: 'apikey_messages_processed_messages_total',
  pendingMessages: 'apikey_pending_messages',
  urlProcessingCount: 'url_processing_time_seconds_count',
  urlProcessingSum: 'url_processing_time_seconds_sum',
  urlProcessingMax: 'url_processing_time_seconds_max',
  urlBackendStatus: 'url_backend_status',
} as const;
